import { render, staticRenderFns } from "./InspectionIncomingList_backlogList.vue?vue&type=template&id=04c5f7d4&scoped=true"
import script from "./InspectionIncomingList_backlogList.vue?vue&type=script&lang=js"
export * from "./InspectionIncomingList_backlogList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04c5f7d4",
  null
  
)

export default component.exports